import EventTagList from './EventTagList'

export default EventTagList
